import { getFilialData } from "./filial-settings";
import { mergeSettings } from "./utils";

const baseFields = {
    routeType: "route_type",
    personalAccount: "personal_amount",
    bonusAccount: "bonus_amount",
};

const fields = {
    costPerMin: "ptime",
    costPerOrder: "porder",
    costPerKm: "pdistance",
    shiftCompletionTime: "timeend",
    mileageLimit: "mileage_limit",
};

// FORMAT FOR CLIENT

const clientFormatters = {};

function formatSalaryFields(settings, emptyFields) {
    const result = {};

    Object.entries(fields).forEach(([field, fieldName]) => {
        if (!emptyFields && !(fieldName in settings)) return;

        const value = settings[fieldName];
        if (clientFormatters[field]) {
            result[field] = clientFormatters[field](value);
        } else {
            result[field] = value;
        }
    });

    return result;
}

export function DeliveryPositionSalary(positionData, filialId) {
    const {
        route_type: routeType,
        personal_amout: personalAccount,
        bonus_amount: bonusAccount,
        setting,
    } = positionData;

    const baseSettings = setting;
    const filialSettings = getFilialData(positionData, filialId);

    const { settings, diff } = mergeSettings(baseSettings, filialSettings);

    return {
        value: {
            routeType,
            personalAccount: !!personalAccount,
            bonusAccount: !!bonusAccount,

            ...formatSalaryFields(settings, true),
        },
        diff: formatSalaryFields(diff),
    };
}

// FORMAT FOR SERVER

const formatters = {
    personalAccount: (v) => (v ? 1 : 0),
    bonusAccount: (v) => (v ? 1 : 0),
};

export function formatDeliveryPositionSalary(positionData) {
    const params = {};

    Object.entries(positionData).forEach(([key, value]) => {
        const fieldName = baseFields[key] || fields[key];
        if (fieldName) {
            if (formatters[key]) {
                params[fieldName] = formatters[key](value);
            } else {
                params[fieldName] = value;
            }
        }
    });

    return params;
}
